import React from 'react';
import Button from 'components/Button';
import styled from 'styled-components';
import { observer } from 'mobx-react';
import user from 'stores/user';
import { useConnectModal } from '@rainbow-me/rainbowkit';
import { GradientBorderBox } from 'components/styled/Box';
import { GA_EVENT_ACTION, GA_EVENT_CATEGORY, trackEvent } from 'utils/googleAnalytics';

const StyledButton = styled(Button)`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px !important;
    /* padding: 15px 30px !important; */
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 30px !important;

    box-shadow: none !important;
`;

interface Props {
    className?: string;
}

function ConnectWallet({ className = '' }: Props) {
    const { openConnectModal } = useConnectModal();
    if (user.connected) return null;

    const onClick = () => {
        openConnectModal?.();
        trackEvent({
            category: GA_EVENT_CATEGORY.Wallet,
            action: GA_EVENT_ACTION.click_connect_wallet,
        });
    };

    return (
        <GradientBorderBox style={{ padding: 0, borderRadius: '25px' }}>
            <StyledButton size="middle" type="transparent" onClick={onClick} className={className}>
                Connect Wallet
            </StyledButton>
        </GradientBorderBox>
    );
}

export default observer(ConnectWallet);
